import { NavigationNode } from "../common/model/NavNode";
import { INavLink } from "office-ui-fabric-react/lib/Nav";

export const getLinks = (node: NavigationNode): INavLink => {
    const link: INavLink = {
        name: node.Title,
        url: node.Url,
        isExpanded: node.Expand || node.IsParentOfCurrent || node.IsCurrent,
        key: node.Id,
    };
    if (node.SubNodes && node.SubNodes.length > 0) {
        link.links = node.SubNodes.map((n, i) => getLinks(n));
    }
    return link;
}

export const GetSelected = (nodes: NavigationNode[]): string => {
    let retval = "";
    nodes.forEach((n) => {
        if (n.IsCurrent) {
            retval = n.Id;
            return;
        }
        const childId = GetSelected(n.SubNodes)
        if (childId != "") {
            retval = childId;
            return;
        }
    });
    return retval;
}